import { useMemo } from 'react';
import { CustomAttributeSidePanelRow } from 'src/components/CustomAttributes/side-panel-row';
import { CLIENT_SECTION_PROPERTIES } from 'src/components/SidePanelTabs/SiteClient/client-section-registry';
import { SITE_SECTION_PROPERTIES } from 'src/components/SidePanelTabs/SiteClient/site-section-registry';
import {
  buildCustomAttributeSidePanelDescriptors,
  useCustomAttributesSidePanel,
} from 'src/graphql/entities/custom-attributes/side-panel-context';
import {
  CLIENT_CARD_PROPERTY_KEYS,
  SITE_CARD_PROPERTY_KEYS,
} from 'src/graphql/entities/side-panel-personalization/model/card-keys';
import type {
  SidePanelSectionData,
  SidePanelSurfaceConfig,
} from 'src/graphql/entities/side-panel-personalization/model/descriptors';
import { UserSettingId } from 'src/graphql/entities/user-setting-value/user-setting-value.types';

const CLIENT_PAGE_CLIENT_PROPERTIES = CLIENT_SECTION_PROPERTIES.filter(
  (property) => property.key !== CLIENT_CARD_PROPERTY_KEYS.labels,
);
const CLIENT_PAGE_SITE_PROPERTIES = SITE_SECTION_PROPERTIES.filter(
  (property) => property.key !== SITE_CARD_PROPERTY_KEYS.labels,
);

function useClientSections(): SidePanelSectionData[] {
  const customAttributes = useCustomAttributesSidePanel();

  return useMemo(
    () => [
      {
        key: 'client' as const,
        label: 'Client',
        loading: customAttributes.loading,
        notice: customAttributes.payloadError ?? undefined,
        hidePanelLabel: true,
        reorderable: true,
        properties: [
          ...CLIENT_PAGE_CLIENT_PROPERTIES,
          ...buildCustomAttributeSidePanelDescriptors(
            customAttributes.rowsByPropertyKey,
            CustomAttributeSidePanelRow,
          ),
        ],
      },
      {
        key: 'site' as const,
        label: 'Site',
        loading: false,
        reorderable: true,
        properties: CLIENT_PAGE_SITE_PROPERTIES,
      },
    ],
    [
      customAttributes.loading,
      customAttributes.payloadError,
      customAttributes.rowsByPropertyKey,
    ],
  );
}

export const clientSidePanelSurface: SidePanelSurfaceConfig = {
  surfaceKey: 'client-page',
  settingIds: {
    profiles: UserSettingId.ClientSidePanelProfiles,
    personalization: UserSettingId.ClientSidePanelPersonalization,
    groupProfile: UserSettingId.ClientSidePanelGroupProfile,
  },
  useSections: useClientSections,
};
